export default __webpack_public_path__ + "static/media/icon-timeline.c08635c1.svg";